import { useEffect } from "react";
import {
  showWarningMessage,
  showSuccessMessage,
} from "@/features/alertSnackbarSlice";
import { useAppDispatch } from "@/storeHooks";

export const useOfflineNotification = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const offlineHandler = ({ type }: Event) => {
      if (type === "offline") {
        dispatch(
          showWarningMessage({
            message:
              "You are currently offline. Nimbus requires connectivity to function properly.",
            duration: null,
            disableClickaway: true,
          })
        );
      } else if (type === "online") {
        dispatch(showSuccessMessage({ message: "You are back online." }));
      }
    };

    window.addEventListener("offline", offlineHandler);
    window.addEventListener("online", offlineHandler);

    return () => {
      window.removeEventListener("offline", offlineHandler);
      window.removeEventListener("online", offlineHandler);
    };
  }, [dispatch]);
};
